import React, { createContext, useContext, useState, useCallback } from 'react';

const HelpContext = createContext();

export const useHelp = () => {
  const context = useContext(HelpContext);
  if (!context) {
    throw new Error('useHelp must be used within HelpProvider');
  }
  return context;
};

export const HelpProvider = ({ children }) => {
  const [tourRunning, setTourRunning] = useState(false);
  const [currentTour, setCurrentTour] = useState(null);
  const [tooltipsEnabled, setTooltipsEnabled] = useState(true);

  const startTour = useCallback((tourName) => {
    setCurrentTour(tourName);
    setTourRunning(true);
  }, []);

  const stopTour = useCallback(() => {
    setTourRunning(false);
    setCurrentTour(null);
  }, []);

  const toggleTooltips = useCallback(() => {
    setTooltipsEnabled(prev => !prev);
  }, []);

  const value = {
    tourRunning,
    currentTour,
    tooltipsEnabled,
    startTour,
    stopTour,
    toggleTooltips,
  };

  return (
    <HelpContext.Provider value={value}>
      {children}
    </HelpContext.Provider>
  );
};

export default HelpContext;

